import { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './Navigation.css';

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleDemoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname !== '/employees') {
      navigate('/employees');
      // Wait for navigation to complete before scrolling
      setTimeout(() => {
        const demoSection = document.getElementById('demo');
        if (demoSection) {
          demoSection.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    } else {
      // If already on employees page, just scroll
      const demoSection = document.getElementById('demo');
      if (demoSection) {
        demoSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <div className="logo" onClick={() => navigate('/')}>
          <img src="/logo.svg" alt="Naya Logo" className="nav-logo" />
          <span>Naya</span>
        </div>
        <div className="nav-links">
          <Link 
            to="/employees" 
            className={`nav-link ${location.pathname === '/employees' ? 'active' : ''}`}
          >
            For Employees
          </Link>
          <Link 
            to="/managers" 
            className={`nav-link ${location.pathname === '/managers' ? 'active' : ''}`}
          >
            For Managers
          </Link>
        </div>
        {(location.pathname === '/employees' || location.pathname === '/managers') && (
          <button onClick={handleDemoClick} className="header-button">
            Try Demo
          </button>
        )}
      </div>
    </header>
  );
}; 